import React, { useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { Plus } from "react-bootstrap-icons";
import {
  resetAddedState,
  fetchUserVocabulary,
  addWordToUserVocabulary,
} from "../redux/slices/userVocabularySlice";
import { UserContext } from "./user/UserContext";

export default function AddToUserVocabulary({ word, translation }) {
  const dispatch = useDispatch(); // Initialize the Redux dispatch function
  const { userAttributes } = useContext(UserContext); // Access user attributes from the context

  // Access the loading and added states from the Redux store
  const { loading, added } = useSelector((state) => state.userVocabulary);

  // Effect to handle actions when a word is successfully added
  useEffect(() => {
    if (added) {
      // Fetch the updated user vocabulary after a word is added
      dispatch(fetchUserVocabulary({ owner: userAttributes.sub }));

      // Reset the added state after a 2-second delay
      setTimeout(() => {
        dispatch(resetAddedState());
      }, 2000);
    }
  }, [added, dispatch, userAttributes.sub]);

  // Function to handle the click event to add a word to the user's vocabulary
  async function handleAddWord() {
    dispatch(
      addWordToUserVocabulary({ word, translation, owner: userAttributes.sub })
    );
  }

  return (
    <Button
      variant="outline-secondary"
      size="sm"
      className="p-0 d-flex align-items-center justify-content-center"
      style={{ width: "24px", height: "24px" }}
      onClick={handleAddWord}
      disabled={loading || added} // Disable the button if loading or the word has already been added
    >
      {/* Show a checkmark if the word has been added, otherwise show a plus icon */}
      {added ? "✓" : <Plus className="w-100 h-100" />}
    </Button>
  );
}
